import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface Option {
  text: string;
  value: number;
}

export function useCaraOptions() {
  const { t } = useTranslation();

  const annualTransactionOptions = useMemo<Option[]>(
    () => [
      { text: '0-20,000', value: 1 },
      { text: '20,001-60,000', value: 2 },
      {
        text: t('fiatWallet.activation.overCertainAmount', {
          amount: '60,000',
        }),
        value: 3,
      },
    ],
    [],
  );

  const annualIncomeOptions = useMemo<Option[]>(
    () => [
      { text: '0-20,000', value: 1 },
      { text: '20,001-40,000', value: 2 },
      { text: '40,001-60,000', value: 3 },
      { text: '60,001-80,000', value: 4 },
      { text: '80,001-100,000', value: 5 },
      {
        text: t('fiatWallet.activation.overCertainAmount', {
          amount: '100,000',
        }),
        value: 6,
      },
    ],
    [],
  );

  const employmentStatusOptions = useMemo<Option[]>(
    () => [
      {
        text: t('fiatWallet.activation.employmentStatus.employed'),
        value: 1,
      },
      {
        text: t('fiatWallet.activation.employmentStatus.selfEmployed'),
        value: 2,
      },
      {
        text: t('fiatWallet.activation.employmentStatus.student'),
        value: 3,
      },
      {
        text: t('fiatWallet.activation.employmentStatus.pensioner'),
        value: 4,
      },
      {
        text: t('fiatWallet.activation.employmentStatus.unemployed'),
        value: 5,
      },
    ],
    [],
  );

  return {
    annualTransactionOptions,
    annualIncomeOptions,
    employmentStatusOptions,
  };
}
